import React, { FC, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { LinearProgress, Backdrop } from '@mui/material'
import useStyles from './loader-style'

const portal = document.getElementById('portal') as HTMLElement

interface IProps {
  visible?: boolean
}

const Loader: FC<IProps> = ({ visible = true }) => {
  const { classes } = useStyles()
  const [el, setEl] = useState(document.createElement('div'))

  useEffect(() => {
    portal?.appendChild(el)

    return () => {
      portal?.removeChild(el)
    }
  }, [el, setEl])

  return visible ? (
    createPortal(
      <>
        <LinearProgress color="primary" />
        <Backdrop open invisible className={classes.backdrop} />
      </>,
      el,
    )
  ) : (
    <div />
  )
}

export default Loader
